import React, { useState, useEffect } from 'react';
import { FileText, ListChecks, Clock, Zap, LogOut, AlertTriangle, X } from 'lucide-react';

export default function TopBar({ clock, notionData, onLogout }) {
  const todayPosts  = notionData?.summary?.todayPosts  || 0;
  const pendingTodos = notionData?.summary?.pendingTodos || 0;
  const totalPosts  = notionData?.summary?.totalPosts  || 0;

  const [budgetAlert, setBudgetAlert] = useState(null);
  const [dismissed, setDismissed]     = useState(false);

  useEffect(() => {
    try {
      const usage = JSON.parse(localStorage.getItem('caio_token_usage') || '{"history":[]}');
      const thisMonth = new Date().toISOString().slice(0, 7);
      const monthCost = (usage.history || [])
        .filter(h => (h.time || '').startsWith(thisMonth))
        .reduce((s, h) => s + (h.cost || 0), 0);
      const threshold = parseFloat(localStorage.getItem('caio_budget') || '5.0');
      if (monthCost >= threshold) {
        setBudgetAlert({ cost: monthCost, threshold, pct: Math.round((monthCost / threshold) * 100) });
      }
    } catch {}
  }, []);

  return (
    <>
      <header className="topbar" role="banner">
        <div className="topbar-left">
          <span className="logo">블로그오빠<span className="logo-sub">CAIO</span></span>
          <span className="badge-active" aria-label="라이브 운영 중"><span className="badge-dot" aria-hidden="true" />LIVE</span>
        </div>
        <div className="topbar-right">
          <span className="stat" aria-label={`총 포스트 ${totalPosts}개`}><Zap size={12} aria-hidden="true" /><b>{totalPosts}</b> 포스트</span>
          <span className="stat notion-stat" aria-label={`오늘 포스트 ${todayPosts}개`}><FileText size={12} aria-hidden="true" /><b>{todayPosts}</b> 오늘</span>
          <span className="stat todo-stat" aria-label={`미완료 ${pendingTodos}개`}><ListChecks size={12} aria-hidden="true" /><b>{pendingTodos}</b> 미완료</span>
          <span className="stat clock" aria-label={`현재 시각 ${clock}`} aria-live="off"><Clock size={12} aria-hidden="true" />{clock}</span>
          {onLogout && (
            <button
              className="topbar-logout-btn"
              onClick={onLogout}
              aria-label="로그아웃"
              title="로그아웃"
            >
              <LogOut size={13} aria-hidden="true" />
            </button>
          )}
        </div>
      </header>
      {budgetAlert && !dismissed && (
        <div className="n-budget-alert" role="alert">
          <AlertTriangle size={12} aria-hidden="true" />
          <span>
            AI 비용 경보 — 이번달{' '}
            <b style={{ fontFamily: 'Outfit' }}>${budgetAlert.cost.toFixed(2)}</b>
            {' '}사용 ({budgetAlert.pct}% · 예산 ${budgetAlert.threshold.toFixed(0)})
          </span>
          <button
            className="n-budget-alert-close"
            onClick={() => setDismissed(true)}
            aria-label="경보 닫기"
            title="닫기"
          >
            <X size={11} />
          </button>
        </div>
      )}
    </>
  );
}
